import React, { FC } from 'react';
import { CrewMember } from '@bechtel/types';
import { Box, Text } from '@bechtel/gds';
import { useName } from '@bechtel/client-common';
import { AvatarRegularStyled } from './styled';

interface CrewEmployeeItemProps {
  crewMember: CrewMember;
  crewNumber: string;
}
export const CrewEmployeeItem: FC<CrewEmployeeItemProps> = ({ crewMember, crewNumber }) => {
  const { getFullName } = useName();
  return (
    <Box flexGrow={{ sm: 1 }}>
      <Box>
        <AvatarRegularStyled src={crewMember?.imageUrl ? crewMember?.imageUrl : undefined} />
      </Box>
      <Box flexDirection={{ sm: 'column' }}>
        <Text weight="600" size="300" color="grey.1000" style={{ lineHeight: 1.5 }}>
          {getFullName(crewMember?.firstName, crewMember?.lastName)}
        </Text>
        <Text size="200" color="grey.600" transform="capitalize">
          {crewMember.subGroupDescription
            ? `${crewMember.subGroupDescription} - `
            : crewMember.persona
            ? `${crewMember.persona.replace(/_/g, ' ').toLowerCase()} - `
            : ''}
          {crewNumber}
        </Text>
        <Text size="200" color="grey.600">
          {crewMember.discipline}
        </Text>
      </Box>
    </Box>
  );
};
